<template>
  <page-header-wrapper>
    <a-card>
      <div class="app-container">
        <a-radio-group v-model="pagetype" style="margin-bottom: 16px">
          <a-radio-button :value="1">
            分销账号管理
          </a-radio-button>
          <a-radio-button :value="2">
            分销商二维码
          </a-radio-button>
          <a-radio-button :value="3">
            分销层级
          </a-radio-button>
        </a-radio-group>
        <div v-show='pagetype == 1'>
          <div class="table-operations">
            <table-setting
              :style="{float: 'right'}"
              :table-size.sync="tableSize"
              v-model="columns"
              :refresh-loading="loading"
              :pagination="false"
              @refresh="getList" />
          </div>
          <a-table :data-source="dataSource" :columns="columns" rowKey="id" :pagination="false">
            <div slot="action" slot-scope="text, record" >
              <a-popconfirm
                title="确定要冻结此账号吗？"
                ok-text="确定"
                cancel-text="取消"
                @confirm="del(record)"
              >
                <a href="javascript:void(0)" class="margin-right-sm">禁用</a>
              </a-popconfirm>
              <a-popconfirm
                title="确定要冻结此账号吗？"
                ok-text="确定"
                cancel-text="取消"
                @confirm="del(record)"
              >
                <a href="javascript:void(0)" style="color:red;">冻结</a>
              </a-popconfirm>
            </div>
          </a-table>
          <!-- 分页 -->
          <a-pagination
            class="ant-table-pagination"
            show-size-changer
            show-quick-jumper
            :current="queryParams.pageNum"
            :total="total"
            :page-size="queryParams.pageSize"
            :showTotal="total => `共 ${total} 条`"
            @showSizeChange="onShowSizeChange"
            @change="changeSize"
          />
        </div>
        <div v-show='pagetype == 2'>
          <a-row :gutter="24">
            <a-col :span="3" v-for='(item, index) in 9' :key="index" class='margin-bottom'>
              <a-card hoverable>
                <img
                  slot="cover"
                  alt="example"
                  src="https://os.alipayobjects.com/rmsportal/QBnOOoLaAfKPirc.png"
                />
                <a-card-meta title="糖猫猫" class='text-center'>
                  <template slot="description">
                    ID:8569
                  </template>
                </a-card-meta>
                <div class='flex justify-around margin-top'>
                  <a-icon type="qrcode" @click='qrvisible = true'/>
                  <a-icon type="qrcode" @click='qrvisible = true'/>
                  <a-icon type="qrcode" @click='qrvisible = true'/>
                </div>
              </a-card>
            </a-col>
            <a-modal
              title="分销二维码"
              :visible="qrvisible"
              :confirm-loading="confirmLoading"
              :footer="null"
              @cancel="qrvisible = false"
            >
              <img
                slot="cover"
                alt="example"
                src="https://os.alipayobjects.com/rmsportal/QBnOOoLaAfKPirc.png"
              />
            </a-modal>
          </a-row>
        </div>
        <div v-show='pagetype == 3'>
          <a-list item-layout="horizontal" :data-source="dataAgency">
            <a-list-item slot="renderItem" slot-scope="item, index">
              <a-list-item-meta
                :description="item.name"
              >
                <a slot="title" href="https://www.antdv.com/">{{ item.memberID }}{{item.type}}</a>
                <a-avatar
                  slot="avatar"
                  src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
                />
              </a-list-item-meta>
            </a-list-item>
          </a-list>
        </div>
      </div>
    </a-card>
  </page-header-wrapper>
</template>
<script>
import { tableMixin } from '@/store/table-mixin'
export default {
  name: "",
  mixins: [tableMixin],
  data() {
    return {
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        name: ''
      },
      pagetype: 1,
      qrvisible: false,
      confirmLoading: false,
      loading: false,
      // 总条数
      total: 0,
      dataSource: [
        {
          id: 1,
          accountID: 338,
          memberID: 23,
          balance: 895678,
          totalIncome: 10000000,
          totalPerformance: 5689774
        }
      ],
      columns: [
        {
          title: '账号ID',
          dataIndex: 'accountID',
          key: 'accountID'
        },{
          title: '会员号',
          dataIndex: 'memberID',
          key: 'memberID'
        },{
          title: '可提佣金余额',
          dataIndex: 'balance',
          key: 'balance'
        },{
          title: '总收入',
          dataIndex: 'totalIncome',
          key: 'totalIncome'
        },{
          title: '总业绩',
          dataIndex: 'totalPerformance',
          key: 'totalPerformance'
        },{
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      dataAgency: [
        {
          id: 1,
          memberID: 60031,
          type: '经销商',
          name: '糖猫猫'
        },{
          id: 2,
          memberID: 60031,
          type: '经销商',
          name: '张大傻'
        }
      ]
    };
  },
  methods: {
    handleClick() {},
    del() {},
    getList() {},
    onShowSizeChange (current, pageSize) {
      this.queryParams.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParams.pageNum = current
      this.queryParams.pageSize = pageSize
      this.getList()
    },
  }
};
</script>
<style scoped lang="less">
.tip {
  line-height: 20px !important;
  font-size: 12px;
}

.margin-bottom-0 {
  margin-bottom: 0 !important;
}
</style>